import {useCallback, useEffect, useState} from "react";
import {EmblaCarouselType} from "embla-carousel";

type EmblaDotsType = {
    selectedIndex: number;
    scrollSnaps: number[];
    onDotButtonClick: (index: number) => void;
}

export const useEmblaDots = (emblaApi: EmblaCarouselType | undefined): EmblaDotsType => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

    const onDotButtonClick = useCallback(
        (index: number) => emblaApi?.scrollTo(index),
        [emblaApi],
    );

    const update = useCallback((api: EmblaCarouselType) => {
        setSelectedIndex(api.selectedScrollSnap());
        setScrollSnaps(api.scrollSnapList());
    }, []);

    useEffect(() => {
        if (!emblaApi) return;

        update(emblaApi);

        emblaApi.on("reInit", update);
        emblaApi.on("select", update);

        return () => {
            emblaApi.off("reInit", update);
            emblaApi.off("select", update);
        };
    }, [emblaApi, update]);

    return {
        selectedIndex,
        scrollSnaps,
        onDotButtonClick
    };
}
